import FormField from "../form-field";
import SocialInput from "../inputs/social-input";
export default class SocialField extends FormField {
	constructor(props) {
		super(props);

		this.socialsInput = null;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('SocialsField: Root element is not defined!');
		}

		const $input = this.$root.querySelector('.socials-input');
		this.socialsInput = new SocialInput({ $root: $input });

		super.init();
	}

	addEventListeners() {
		this.socialsInput.subscribe(this.VALUE_CHANGE_EVENT, ({ detail }) => {
			this.setValue(detail);
		});
	}

	setInitialState() {
		this.socialsInput.dropState();
	}
}